import React from 'react';
import CourseCard from './components/CourseCard';
import './CourseCarousel.css';

import { fetchCourses } from '../learning/api';

const CourseCarousel = () => {
  const [courses, setCourses] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    fetchCourses()
      .then(({ data, error }) => {
        if (error) setError(error.message);
        else setCourses(data || []);
        setLoading(false);
      })
      .catch(e => { setError(e.message); setLoading(false); });
  }, []);

  if (loading) return <div className="course-carousel">Loading courses...</div>;
  if (error) return <div className="course-carousel" style={{color:'var(--error)'}}>Error: {error}</div>;

  return (
    <div className="course-carousel" aria-label="Course carousel">
      <div className="carousel-track">
        {courses.map(course => (
          <CourseCard key={course.id} course={course} />
        ))}
      </div>
    </div>
  );
};

export default CourseCarousel; 